// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__5KK8a","header":"MessagesList_header__214up","chat":"MessagesList_chat__3X3O2"};